import React from 'react'

function NotesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
    >
      <g filter="url(#filter0_d_2931_1476)">
        <path
          d="M12.3335 3.33203C13.2698 3.33203 13.738 3.33203 14.0743 3.55674C14.2198 3.65402 14.3448 3.77902 14.4421 3.9246C14.6668 4.2609 14.6668 4.72906 14.6668 5.66536V11.9987C14.6668 13.2558 14.6668 13.8843 14.2763 14.2748C13.8858 14.6654 13.2572 14.6654 12.0002 14.6654H8.00016C6.74308 14.6654 6.11454 14.6654 5.72402 14.2748C5.3335 13.8843 5.3335 13.2558 5.3335 11.9987V5.66536C5.3335 4.72906 5.3335 4.2609 5.5582 3.9246C5.65548 3.77902 5.78048 3.65402 5.92607 3.55674C6.26237 3.33203 6.73052 3.33203 7.66683 3.33203"
          stroke="#393D63"
        />
        <path
          d="M8 3.33333C8 2.59695 8.59695 2 9.33333 2H10.6667C11.403 2 12 2.59695 12 3.33333C12 4.06971 11.403 4.66667 10.6667 4.66667H9.33333C8.59695 4.66667 8 4.06971 8 3.33333Z"
          stroke="#393D63"
        />
        <path d="M8 8L12 8" stroke="#393D63" stroke-linecap="round" />
        <path
          d="M8 10.668L10.6667 10.668"
          stroke="#393D63"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2931_1476"
          x="-2"
          y="0"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2931_1476"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2931_1476"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default NotesIcon
